// extracted by mini-css-extract-plugin
module.exports = {"navToggler":"NavbarToggler_navToggler__3iIJe","isOpen":"NavbarToggler_isOpen__Ut3iz"};